import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import pushToGTM, { pageLoadGA4Tag } from '../../utils/analytics/gtm';
import { useStyles } from './styles';
import InputsForm from '../../components/InputsForm';
import tabbarSlice from '../../components/Tabbar/tabbarSlice';
import Link from '../../components/Link';
import { getDomain } from '../../utils/config';
import { areParamsValidDesignParams } from '../../components/InputsForm/utils';
import { localView } from '../../utils/analytics/local';

const domain = getDomain();
// Can be also used as URL params: https://www.onsemi.com/design-tools/inputs?vinMin=12&vinMax=18&vout=3.3&iout=1&ambientTemperature=25&supplyType=DC&lineFrequency=60&isolated=false&topology=BUCK&ic=NCP3284AMNTXG
const InputsPage = ({ screenWidth, search }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const dispatch = useDispatch();

	useEffect(() => {
		// Don't send input when design is opened by link to design
		if (!(Object.keys(search).length && areParamsValidDesignParams(search))) {
			localView('Inputs');
			pushToGTM(pageLoadGA4Tag('INPUTS'));
		}

		dispatch(tabbarSlice.actions.setProgressActive(false));
	}, [dispatch]);

	return (
		<Grid container justify="center" alignItems="flex-start">
			<Grid item container direction="column" xs={12} sm={9} md={10} lg={7} xl={6} spacing={2}>
				<Grid item className={classes.description}>
					<Typography variant="body2" color="textSecondary" gutterBottom>
						<b>WebDesigner+&trade; Power Supply</b> {t('components.inputs.description')}
					</Typography>

					<Typography variant="body2" color="textSecondary">
						{t('components.inputs.descriptionSecondary')}
						<Link
							variant="body2"
							color="textSecondary"
							href={`https://www.${domain}/terms-of-use`}
							target="_blank"
							underline={'always'}>
							{t('components.inputs.terms')}
						</Link>
						.
					</Typography>
				</Grid>

				<Grid item container>
					<InputsForm screenWidth={screenWidth} search={search} />
				</Grid>
			</Grid>
		</Grid>
	);
};

InputsPage.propTypes = {
	screenWidth: PropTypes.number.isRequired,
	search: PropTypes.object
};

export default InputsPage;
